import { Badge, Menu, UnstyledButton } from '@mantine/core';
import { IconActivity, IconListNumbers, IconPhone, IconSettings, IconTool } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { useUnreviewedCallErrorCount } from './use-unreviewed-call-errors';

const adminPrefixes = ['/settings', '/queue-dashboard', '/active-dashboard', '/calls'];

function CountBadge({ count }: { count: number }) {
  return (
    <Badge size="xs" color="red" variant="filled" circle>
      {count > 99 ? '99+' : count}
    </Badge>
  );
}

export function AdminMenu({ pathname, organizationId }: { pathname: string; organizationId: string | null }) {
  const isActive = adminPrefixes.some((prefix) => pathname.startsWith(prefix));
  const errorCount = useUnreviewedCallErrorCount(organizationId);

  return (
    <Menu position="bottom-end" offset={4}>
      <Menu.Target>
        <UnstyledButton
          px="sm"
          py={6}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            borderRadius: 'var(--mantine-radius-md)',
            backgroundColor: isActive ? 'var(--mantine-color-indigo-light)' : 'transparent',
            color: isActive ? 'var(--mantine-color-indigo-filled)' : 'var(--mantine-color-dimmed)',
            fontWeight: isActive ? 600 : 500,
            fontSize: 'var(--mantine-font-size-sm)',
            transition: 'background-color 150ms ease, color 150ms ease',
          }}
        >
          <IconTool size={16} stroke={1.5} />
          Admin
          {errorCount > 0 && <CountBadge count={errorCount} />}
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          component={Link}
          to="/active-dashboard"
          leftSection={<IconActivity size={14} />}
          rightSection={errorCount > 0 ? <CountBadge count={errorCount} /> : undefined}
        >
          Active Dashboard
        </Menu.Item>
        <Menu.Item component={Link} to="/calls" leftSection={<IconPhone size={14} />}>
          Calls
        </Menu.Item>
        <Menu.Item component={Link} to="/queue-dashboard" leftSection={<IconListNumbers size={14} />}>
          Queue Dashboard
        </Menu.Item>
        <Menu.Item component={Link} to="/settings" leftSection={<IconSettings size={14} />}>
          Settings
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
